import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const ImprovingSol = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Improving our design and technical aspects</Paragraph>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-9vh'}}>Our design</Paragraph>
        <Text style={{textAlign: 'justify', textJustify: 'inter-word'}} className='BaseText'>A detailed description of the sensor is provided in the project description page, however this information is provided as context for the following sections. iMoAges´s purpose is to monitor the dynamics of biomarkers related to inflammaging. We designed a <b>multiplex lateral flow assay</b> to obtain semi quantitative results by a <b>colorimetric signal.</b>, produced by the union of aptamers to their specific biomarker. This kind of test is considered as a Point of Care device and it requires a sample of blood.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default ImprovingSol;
